export default "__VITE_ASSET__K8QrWVVz__"